/* src/app/shared/controls/switch-control/switch-control.component.scss */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 24px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.switch input:checked + .slider {
  background-color: #007bff;
}
.switch input:checked + .slider:before {
  transform: translateX(34px);
}
.switch .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  border-radius: 24px;
  transition: 0.4s;
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-size: 12px;
  color: white;
  font-weight: bold;
}
.switch .slider .toggle-text {
  position: absolute;
  width: 100%;
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  color: white;
  padding-inline-start: 10px;
  padding-inline-end: 0px;
}
.switch .slider .toggle-text.selected {
  padding-inline-start: 0px;
  padding-inline-end: 10px;
}
.switch .slider:before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 4px;
  bottom: 3px;
  background-color: white;
  border-radius: 50%;
  transition: 0.4s;
}
.switch:hover {
  cursor: pointer;
}
/*# sourceMappingURL=switch-control.component-SAB24CVK.css.map */
